import { apiClient } from './apiClient'
import { authService } from './authService'
import { getRefreshToken, setAccessToken, setRefreshToken } from './authStorage'

const REFRESH_INTERVAL_MS = 20 * 60 * 1000

let refreshInterval = null
let refreshPromise = null

export const tokenRefreshService = {
  start() {
    this.stop()
    refreshInterval = setInterval(() => {
      this.refreshIfNeeded().catch(() => {})
    }, REFRESH_INTERVAL_MS)
  },

  stop() {
    if (refreshInterval) {
      clearInterval(refreshInterval)
      refreshInterval = null
    }
    refreshPromise = null
  },

  async refreshIfNeeded() {
    if (!authService.isAuthenticated()) {
      return false
    }

    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      return false
    }

    if (refreshPromise) {
      return refreshPromise
    }

    refreshPromise = (async () => {
      try {
        const data = await apiClient.post('/auth/refresh', { refreshToken }, { auth: false })
        if (data?.accessToken) {
          setAccessToken(data.accessToken)
        }
        if (data?.refreshToken) {
          setRefreshToken(data.refreshToken)
        }
        return Boolean(data?.accessToken)
      } catch {
        return false
      } finally {
        refreshPromise = null
      }
    })()

    return refreshPromise
  }
}
